// The two things that play the game when the player is not, as one face
// (PLAN-CLIENT-SPLIT day 7): the opponent and the run director. One options
// object in, because they are one subject — who moves while you are not
// moving.

import type { Drivers } from "src/api";

import type { DriverDoor } from "./driver";
import { RunDirector } from "./director";
import { OpponentDriver, type OpponentDriverOptions } from "./opponent";

export type { DriverDoor, DriverEmit } from "./driver";
export { DEFAULT_OPTIONS, NOBODY, OpponentDriver } from "./opponent";
export { RunDirector } from "./director";

export interface EngineDrivers extends Drivers {
  dispose(): void;
}

export function createDrivers(door: DriverDoor, options: OpponentDriverOptions = {}): EngineDrivers {
  const opponent = new OpponentDriver(door, options);
  const director = new RunDirector(door);
  return {
    configure(next) {
      opponent.configure(next);
      // In a run the director reveals regions. Whether this is a run is the
      // board's to say, so it is not a knob.
      director.configure(opponent.options.enabled);
    },
    branch: () => opponent.branch(),
    pick: (index) => opponent.pick(index),
    dispose() {
      opponent.dispose();
      director.dispose();
    }
  };
}
